module.exports = __webpack_public_path__ + "img/revista-madrigal-02.04b20dc0.jpg";